import './styles/tokens.css';
import './styles/reset.css';
import './styles/win95.css';
import './styles/a11y.css';
import { boot } from './app';

const app = document.getElementById('app');
if (!app) throw new Error('#app missing');
boot(app);
